import { render } from "./Account.vue?vue&type=template&id=7cbffb3a&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=7cbffb3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbffb3a"],['__file',"src/views/Account.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cbffb3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cbffb3a', __exports__)) {
    api.reload('7cbffb3a', __exports__)
  }
  
  module.hot.accept("./Account.vue?vue&type=template&id=7cbffb3a&scoped=true", () => {
    api.rerender('7cbffb3a', render)
  })

}


export default __exports__